module.exports = __webpack_public_path__ + "static/media/hockey-sticks.dccd14f5.svg";